import React from 'react'
import styled from 'styled-components'
import { ButtonGradientFilled } from 'components/Button'
import { IMaskInput } from 'react-imask'
import colors from '../../../styles/colors'

const INPUT_HEIGHT = 50

const InputForm = styled.form`
  width: 100%;
  position: relative;
  padding-bottom: 30px;
`

const InputWrap = styled.div`
  position: relative;
`

const StyledInput = styled(IMaskInput)`
  width: 100%;
  padding-left: 10px;
  height: ${INPUT_HEIGHT}px;
  font-size: 16px;
  font-weight: 500;
  border: 0;
  border-radius: 7px;
  &,
  &:focus {
    outline: none;
  }
`

const ButtonStyled = styled(ButtonGradientFilled)`
  position: absolute;
  right: 0;
  top: 0;
  height: 50px;
  z-index: 1;
  width: 90px;
  padding-left: 10px;
  padding-right: 10px;
`

const ErrorMessage = styled.p`
  position: absolute;
  top: 60px;
  left: 0;
  margin-bottom: 0;
  font-size: 12px;
  line-height: 16px;
  color: ${colors.red};
`

const InfoText = styled.p`
  position: absolute;
  top: 60px;
  left: 0;
  margin-bottom: 0;
  font-size: 14px;
  line-height: 16px;
  color: ${colors.black};
`

const ContactForm = ({
  inputProps,
  buttonProps,
  onSubmit,
  error,
  infoText,
}) => (
  <InputForm onSubmit={onSubmit}>
    <InputWrap>
      <StyledInput {...inputProps} />
      <ButtonStyled {...buttonProps}>
        <span>Text Me</span>
      </ButtonStyled>
    </InputWrap>
    {error && <ErrorMessage>{error}</ErrorMessage>}
    {infoText && <InfoText>{infoText}</InfoText>}
  </InputForm>
)

export default ContactForm
